
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { ActivityFeed } from './ActivityFeed';
import { BoardPresenceAvatars } from '@/components/kanban/BoardPresenceAvatars';
import { useBoardContext } from '@/contexts/BoardContext';
import { useBoardPresence } from '@/contexts/BoardPresenceContext';
import { useAuth } from '@/hooks/useAuth';

interface CollaborationSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  className?: string;
}

export function CollaborationSidebar({
  isOpen,
  onClose,
  className
}: CollaborationSidebarProps) {
  const { currentBoardId } = useBoardContext();
  const { user } = useAuth();
  
  // Use the unified BoardPresenceContext
  const { presenceUsers } = useBoardPresence();

  if (!isOpen || !currentBoardId) {
    return null;
  }

  // Filter board-level presence users (those without card_id)
  const boardUsers = presenceUsers.filter(user => !user.card_id);

  return (
    <div className={`w-80 bg-background border-l border-border h-full flex flex-col ${className}`}>
      <Card className="h-full">
        <CardHeader className="pb-3">
          <div className="flex items-center justify-between">
            <CardTitle className="text-lg">Collaboration</CardTitle>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
            >
              ✕
            </button>
          </div>
        </CardHeader>

        <CardContent className="flex-1 space-y-4 overflow-hidden">
          {/* Active users */}
          <div>
            <h4 className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">
              Active Users
            </h4>
            <BoardPresenceAvatars 
              users={boardUsers}
              currentUserId={user?.id || ''}
            />
          </div>

          <Separator />

          {/* Activity feed */}
          <ActivityFeed 
            boardId={currentBoardId} 
            className="flex-1 overflow-hidden"
          />
        </CardContent>
      </Card>
    </div>
  );
}
